import { msg } from '@lingui/core/macro';
import type { MessageDescriptor } from 'shared/i18n';

export const CHAT_HISTORY_WINDOW = 12;

export const CHAT_FEATURE_REQUIRED_MESSAGE: MessageDescriptor = msg`ИИ-ассистент доступен только на платном тарифе. Свяжитесь с нами, чтобы подключить его.`;
